import { createElement } from 'react';
import { createRoute, type AnyRoute } from '@tanstack/react-router';
import { CAMINHO_ENTREGA, CAMINHO_ENTREGAS } from '@/features/releases/navegacao';
import { ReleasePage } from '@/features/releases/ReleasePage';
import { ReleasesPage } from '@/features/releases/ReleasesPage';

/**
 * Rotas das versões de entrega.
 *
 * Duas rotas irmãs, e não uma raiz com filhas: a lista e a ficha não
 * compartilham casca. A ficha é uma tela inteira, com cabeçalho próprio e
 * caminho de volta — a mesma decisão de `features/clientes/routes.ts`.
 *
 * Fora de `/mudancas` de propósito: o ITIL separa **mudança** — autorização e
 * controle do risco — de **release** — empacotar e disponibilizar. Uma versão
 * de entrega não é um chamado: não tem solicitante, não tem SLA e não entra na
 * fila. Pendurá-la como aba do calendário de mudanças ensinaria o contrário.
 */
export function criarRotasDeEntregas<TRotaPai extends AnyRoute>(rotaPai: TRotaPai) {
  const lista = createRoute({
    getParentRoute: () => rotaPai,
    path: CAMINHO_ENTREGAS,
    component: ReleasesPage,
  });

  const detalhe = createRoute({
    getParentRoute: () => rotaPai,
    path: CAMINHO_ENTREGA,
    // `createElement` em vez de JSX para este arquivo continuar sendo `.ts`, e
    // a conversão do parâmetro porque o roteador só consegue inferir
    // `{ releaseId }` depois que a árvore estiver registrada.
    component: () => {
      const { releaseId } = detalhe.useParams() as { releaseId: string };
      return createElement(ReleasePage, { releaseId });
    },
  });

  return { lista, detalhe };
}

export { CAMINHO_ENTREGA, CAMINHO_ENTREGAS };
